import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { toast } from "react-toastify";
import axios from 'axios';
import moment from 'moment';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

const NewVehicleRegistrations = props => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNewRegistrations();
  }, []);

  const fetchNewRegistrations = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_APP_URL}/api/web/new-vehicle-registrations`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success && response.data.data) {
        setData(response.data.data);
      } else {
        toast.error('Failed to fetch new vehicle registrations', {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error fetching new vehicle registrations:", error);
      toast.error('Failed to fetch new vehicle registrations', {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (vehicleId) => {
    navigate(`/new-vehicle-registrations/${vehicleId}`);
  };

  const columns = useMemo(
    () => [
      {
        header: 'License Plate',
        accessorKey: 'license_plate',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Make',
        accessorKey: 'make_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Model',
        accessorKey: 'model_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Body Type',
        accessorKey: 'body_type',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Year',
        accessorKey: 'year',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Driver Name',
        accessorKey: 'driver_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Pending Docs',
        accessorKey: 'pending_documents_count',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const count = row.original.pending_documents_count || 0;
          return (
            <span className="badge bg-warning">{count}</span>
          );
        }
      },
      {
        header: 'Registration Date',
        accessorKey: 'created_at',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          return moment(row.original.created_at).format('YYYY-MM-DD HH:mm');
        }
      },
      {
        header: 'Action',
        id: 'action',
        cell: ({ row }) => {
          return (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => handleViewDetails(row.original.vehicle_id)}
            >
              <i className="mdi mdi-eye"></i> View Details
            </button>
          );
        }
      }
    ],
    []
  );

  document.title = "New Vehicle Registrations | Moeen";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="New Vehicle Registrations" />
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <TableContainer
            columns={columns}
            data={data || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder={`Looking for something? ${data.length} results loaded.`}
            pagination="pagination"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
          />
        )}
      </div>
    </div>
  );
};

NewVehicleRegistrations.propTypes = {
  t: PropTypes.any
};

export default NewVehicleRegistrations;

